export { default as OnrampWidget } from './widget/index.js'
